module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic8.38c0cfbd.png";